import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Descriptions, Divider, Popover, Space } from 'antd'
import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { EaAuctionIcon } from '@eastcoal/icon/EaAuctionIcon'
import { EaBidMethodIcon } from '@eastcoal/icon/EaBidMethodIcon'
import { EaTimeIcon } from '@eastcoal/icon/EaTimeIcon'
import { BidPriceTypeTextMap } from '@eastcoal/shared/enums/BidPriceType'

import { useAuctionDetailStore } from '../../../Store/hooks/useStore'

const useStyles = createStyles(({ token, prefixCls }) => ({
  container: {
    width: '100%',
    marginBlockStart: token.marginSM,
    paddingInline: token.paddingMD
  },
  item: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginInlineEnd: token.marginXXS,
    color: token.colorErrorText,
    fontSize: token.fontSizeXL
  },
  label: {
    color: token.colorTextLabel
  },
  value: {
    color: token.colorText,
    fontWeight: token.fontWeightStrong
  },
  tipWrapper: {
    width: 300,
    [`.${prefixCls}-descriptions-item-label`]: {
      color: token.colorTextBase
    }
  }
}))

const Item = ({ icon, label, value, tip }: any) => {
  const { styles } = useStyles()

  const labelDom = <span className={styles.label}>{label}：</span>
  const valueDom = <span className={styles.value}>{value}</span>

  return (
    <div className={styles.item}>
      <span className={styles.icon}> {icon}</span>
      {tip ? (
        <Popover content={tip} trigger='hover'>
          <QuestionCircleOutlined />
          {labelDom}
        </Popover>
      ) : (
        labelDom
      )}
      {valueDom}
    </div>
  )
}

export const MethodBar = () => {
  const { styles } = useStyles()

  const { detailData, currentDelayCount, isBidOnlyOnce } =
    useAuctionDetailStore(state =>
      pick(state, ['detailData', 'currentDelayCount', 'isBidOnlyOnce'])
    )

  const { wholeSale, allowDelay, delayTotalCount, bidPriceType } = detailData

  const bidMethodText = wholeSale ? '整体拍' : '拆分拍'

  const delayText = allowDelay
    ? `延时拍（${currentDelayCount}/${delayTotalCount}次）`
    : '定时拍'

  const bidPriceTypeText = isNil(bidPriceType)
    ? '-'
    : BidPriceTypeTextMap[bidPriceType]

  const timeDescriptions = (
    <Descriptions
      className={styles.tipWrapper}
      column={1}
      layout='horizontal'
      size='small'
      items={[
        {
          label: '定时拍',
          children: '到达结束时间后，则竞价结束'
        },
        {
          label: '延时拍',
          children:
            '每当距结束时间在 1 分钟之内时，若有出价则顺延 1 分钟/次，最多顺延次数由场次设定的延时次数而定'
        }
      ]}
    />
  )

  const items = [
    {
      icon: <EaAuctionIcon />,
      label: '竞价方式',
      value: bidMethodText
    },
    {
      icon: <EaTimeIcon />,
      label: (
        <Popover content={timeDescriptions}>
          <span>计时方式</span>
          <InfoCircleOutlined />
        </Popover>
      ),
      value: delayText
    }
  ]
  if (isBidOnlyOnce()) {
    items.push({
      icon: <EaBidMethodIcon />,
      label: '出价方式',
      value: bidPriceTypeText
    })
  }

  return (
    <Space
      className={styles.container}
      separator={<Divider orientation='vertical' />}
    >
      {items.map(item => (
        <Item key={item.label} {...item} />
      ))}
    </Space>
  )
}
